import { useMemo, useState } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import styled from "styled-components";
import { z } from "zod";
import { Button } from "../../atoms/Button";
import { Input } from "../../atoms/Input";
import FormTemplate from "../../templates/FormTemplate";

type Props = {
  handleSubmit: (otp: string) => void;
  handleResendSms: () => void;
};

export const SmsRegistrationForm: React.FC<Props> = ({
  handleSubmit,
  handleResendSms,
}) => {
  const schema = useMemo(() => {
    return z.object({
      otp: z.string().min(1),
    });
  }, []);

  const [methods, setMethods] = useState<UseFormReturn<
    FieldValues,
    unknown,
    FieldValues
  > | null>(null);

  return (
    <FormTemplate
      schema={schema}
      setMethods={setMethods}
      defaultValues={{ otp: "" }}
      onSubmit={({ otp }) => handleSubmit(otp)}
    >
      <StyledDescriptionContainer>
        <StyledTextContainer>
          SMS認証を行います。SMSで受信した6桁の認証番号を入力してください。
        </StyledTextContainer>

        <StyledInstructionContainer>
          <StyledInstructionTitle>
            SMSが届いていない場合：
          </StyledInstructionTitle>

          <StyledInstructionList>
            <div>・</div>
            サーバーが混んでいる場合もございます。しばらく経ってから再度お試しください。
          </StyledInstructionList>

          <StyledInstructionList>
            <div>・</div>
            モバイル通信ができない状態になっていないかご確認ください。
          </StyledInstructionList>
        </StyledInstructionContainer>
      </StyledDescriptionContainer>

      <Input label="認証番号" name="otp" autoFocus />

      <StyledFooter>
        <Button variant="filled" text="認証" type="submit" fullWidth />
        <Button
          variant="link"
          text="SMSを再送信"
          type="button"
          onClick={handleResendSms}
        />
      </StyledFooter>
    </FormTemplate>
  );
};

const StyledDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  margin-bottom: 24px;
`;

const StyledTextContainer = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
`;

const StyledInstructionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const StyledInstructionTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
`;

const StyledInstructionList = styled.div`
  display: flex;
  gap: 4px;
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
`;

const StyledFooter = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  gap: 20px;
`;
